module.exports = __webpack_public_path__ + "static/media/gif-green.9bc83ef4.svg";